export default {
  nav: {
    home: "ਹੋਮ", about: "ਸਾਡੇ ਬਾਰੇ", services: "ਸੇਵਾਵਾਂ", countries: "ਦੇਸ਼",
    why: "ਸਾਨੂੰ ਕਿਉਂ ਚੁਣੋ", stories: "ਸਫਲਤਾ ਦੀਆਂ ਕਹਾਣੀਆਂ", faq: "ਸਵਾਲ-ਜਵਾਬ", blog: "ਬਲੌਗ", contact: "ਸੰਪਰਕ",
    consultation: "ਮੁਫ਼ਤ ਸਲਾਹ", call: "ਹੁਣੇ ਕਾਲ ਕਰੋ", whatsapp: "ਵਟਸਐਪ",
  },
  hero: {
    eyebrow: "ਇਮੀਗਰੇਸ਼ਨ ਅਤੇ ਵੀਜ਼ਾ ਕੰਸਲਟੈਂਸੀ — ਪੰਜਾਬ, ਭਾਰਤ",
    title1: "ਤੁਹਾਡਾ ਸਫ਼ਰ", title2: "ਇਥੋਂ ਸ਼ੁਰੂ",
    sub: "ਤੁਹਾਡੇ ਗਲੋਬਲ ਭਵਿੱਖ ਲਈ ਪੇਸ਼ੇਵਰ ਇਮੀਗਰੇਸ਼ਨ ਅਤੇ ਵੀਜ਼ਾ ਸਹਾਇਤਾ",
    desc: "ਵਰਕ ਪਰਮਿਟ, ਵਿਜ਼ਿਟਰ ਵੀਜ਼ਾ, ਇਮੀਗਰੇਸ਼ਨ ਦਸਤਾਵੇਜ਼ਾਂ ਅਤੇ ਅਰਜ਼ੀ ਸਹਾਇਤਾ ਲਈ ਪੇਸ਼ੇਵਰ ਮਾਰਗਦਰਸ਼ਨ ਨਾਲ ਅੰਤਰਰਾਸ਼ਟਰੀ ਮੌਕਿਆਂ ਦੀ ਖੋਜ ਕਰੋ।",
    cta1: "ਮੁਫ਼ਤ ਸਲਾਹ ਲਓ", cta2: "ਆਪਣੀ ਯੋਗਤਾ ਜਾਂਚੋ",
    trust: ["ਪੇਸ਼ੇਵਰ ਮਾਰਗਦਰਸ਼ਨ", "ਨਿੱਜੀ ਸਹਾਇਤਾ", "ਪਾਰਦਰਸ਼ੀ ਪ੍ਰਕਿਰਿਆ"],
  },
  enquiry: {
    eyebrow: "ਮੁਫ਼ਤ ਸਲਾਹ",
    title: "ਅੱਜ ਹੀ ਆਪਣਾ ਵੀਜ਼ਾ ਸਫ਼ਰ ਸ਼ੁਰੂ ਕਰੋ",
    desc: "ਕੁਝ ਵੇਰਵੇ ਸਾਂਝੇ ਕਰੋ — ਸਾਡੀ ਟੀਮ ਤੁਹਾਡੇ ਟਿਚਿਆਂ ਅਤੇ ਅੱਗੇ ਦੇ ਰਾਹ ਬਾਰੇ ਗੱਲ ਕਰਨ ਲਈ ਸੰਪਰਕ ਕਰੇਗੀ।",
    name: "ਪੂਰਾ ਨਾਮ", phone: "ਫ਼ੋਨ ਨੰਬਰ", email: "ਈਮੇਲ ਪਤਾ", city: "ਸ਼ਹਿਰ",
    visaType: "ਵੀਜ਼ਾ ਕਿਸਮ", country: "ਪਸੰਦੀਦਾ ਦੇਸ਼", message: "ਸੁਨੇਹਾ",
    submit: "ਪੁੱਛਗਿੱਛ ਭੇਜੋ", submitting: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
    successTitle: "ਤੁਹਾਡੀ ਪੁੱਛਗਿੱਛ ਲਈ ਧੰਨਵਾਦ।",
    successText: "ਤੁਹਾਡੇ ਵੇਰਵੇ THE TRIP WORLD ਨੂੰ ਮਿਲ ਗਏ ਹਨ। ਸ਼੍ਰੀ ਧੀਰਜ ਕਟਾਰੀਆ ਦੀ ਟੀਮ ਜਲਦੀ ਹੀ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰਕੇ ਮੁਫ਼ਤ ਸਲਾਹ ਦਾ ਸਮਾਂ ਤੈਅ ਕਰੇਗੀ।",
    another: "ਹੋਰ ਪੁੱਛਗਿੱਛ ਭੇਜੋ",
  },
  about: {
    eyebrow: "01 — ਅਸੀਂ ਕੌਣ ਹਾਂ",
    title1: "ਤੁਹਾਡਾ ਸਫ਼ਰ.", title2: "ਸਾਡਾ ਮਾਰਗਦਰਸ਼ਨ.",
    p1: "THE TRIP WORLD ਅਹਮਦਗੜ੍ਹ, ਪੰਜاب ਵਿੱਚ ਸਥਿਤ ਇੱਕ ਪੇਸ਼ੇਵਰ ਇਮੀਗਰੇਸ਼ਨ ਅਤੇ ਵੀਜ਼ਾ ਕੰਸਲਟੈਂਸੀ ਹੈ। ਅਸੀਂ ਅੰਤਰਰਾਸ਼ਟਰੀ ਯਾਤਰਾ, ਕੰਮ, ਪੜ੍ਹਾਈ ਅਤੇ ਇਮੀਗਰੇਸ਼ਨ ਦੇ ਮੌਕੇ ਲੱਭਣ ਵਾਲੇ ਵਿਅਕਤੀਆਂ ਅਤੇ ਪਰਿਵਾਰਾਂ ਨਾਲ ਕੰਮ ਕਰਦੇ ਹਾਂ।",
    p2: "ਸਾਡੀ ਟੀਮ ਨਿੱਜੀ ਸਲਾਹ, ਦਸਤਾਵੇਜ਼ੀ ਮਾਰਗਦਰਸ਼ਨ ਅਤੇ ਅਰਜ਼ੀ ਸਹਾਇਤਾ ਦਿੰਦੀ ਹੈ — ਇਮਾਨਦਾਰ ਸਲਾਹ, ਸੁਵਿਵਸਥਿਤ ਪ੍ਰਕਿਰਿਆ ਅਤੇ ਹਰ ਕਦਮ 'ਤੇ ਸਪਸ਼ਟ ਗੱਲਬਾਤ ਨਾਲ।",
    quote: "ਹਰ ਸਫ਼ਰ ਸਹੀ ਮਾਰਗਦਰਸ਼ਨ ਨਾਲ ਸ਼ੁਰੂ ਹੁੰਦਾ ਹੈ। ਸਾਡਾ ਕੰਮ ਤੁਹਾਡੀ ਅਰਜ਼ੀ ਪ੍ਰਕਿਰਿਆ ਨੂੰ ਸਪਸ਼ਟ, ਸੁਵਿਵਸਥਿਤ ਅਤੇ ਤਣਾਅ-ਮੁਕਤ ਬਣਾਉਣਾ ਹੈ।",
    founder: "ਸ਼੍ਰੀ ਧੀਰਜ ਕਟਾਰੀਆ", founderRole: "ਸੰਸਥਾਪਕ, THE TRIP WORLD",
    learnMore: "ਹੋਰ ਜਾਣੋ",
  },
  services: {
    eyebrow: "02 — ਅਸੀਂ ਕੀ ਕਰਦੇ ਹਾਂ", title: "ਸਾਡੀਆਂ ਸੇਵਾਵਾਂ",
    desc: "ਤੁਹਾਡੇ ਮੰਜ਼ਿਲ ਅਤੇ ਟਿਚਿਆਂ ਅਨੁਸਾਰ ਸੰਪੂਰਨ ਵੀਜ਼ਾ ਅਤੇ ਇਮੀਗਰੇਸ਼ਨ ਸਹਾਇਤਾ।",
    learnMore: "ਹੋਰ ਜਾਣੋ",
  },
  countries: {
    eyebrow: "03 — ਮੰਜ਼ਿਲਾਂ", title: "ਆਪਣੀ ਗਲੋਬਲ ਮੰਜ਼ਿਲ ਚੁਣੋ",
    desc: "ਕੈਨੇਡਾ ਤੋਂ ਲੈ ਕੇ UAE ਤੱਕ — ਜਾਣੋ ਕਿਹੜੇ ਰਾਹਾਂ ਦੀ ਤਿਆਰੀ ਵਿੱਚ ਅਸੀਂ ਤੁਹਾਡੀ ਮਦਦ ਕਰ ਸਕਦੇ ਹਾਂ।",
    explore: "ਜਾਣੋ",
    names: {
      canada: "ਕੈਨੇਡਾ", "united-kingdom": "ਯੂਨਾਈਟਡ ਕਿੰਗਡਮ", australia: "ਆਸਟ੍ਰੇਲੀਆ",
      usa: "ਅਮਰੀਕਾ", "new-zealand": "ਨਿਊਜ਼ੀਲੈਂਡ", europe: "ਯੂਰਪ (ਸ਼ੈਂਗਨ)",
      germany: "ਜਰਮਨੀ", france: "ਫਰਾਂਸ", uae: "ਯੂਏਈ",
    },
    blurbs: {
      canada: "ਹੁਨਰਮੰਦ ਕਾਮਿਆਂ, ਵਿਦਿਆਰਥੀਆਂ ਅਤੇ ਪਰਿਵਾਰਾਂ ਲਈ ਮੋਹਰੀ ਮੰਜ਼ਿਲ।",
      "united-kingdom": "ਵਿਸ਼ਵ-ਪੱਧਰੀ ਯੂਨੀਵਰਸਿਟੀਆਂ ਅਤੇ ਗਲੋਬਲ ਕਰੀਅਰ ਮੌਕੇ।",
      australia: "ਸਿੱਖਿਆ, ਕੰਮ ਅਤੇ ਯਾਤਰਾ ਲਈ ਇੱਕ ਜੀਵੰਤ ਮੰਜ਼ਿਲ।",
      usa: "ਅਮਰੀਕਾ ਵਿੱਚ ਕਾਰੋਬਾਰ, ਸੈਰ-ਸਪਾਟਾ ਅਤੇ ਪੜ੍ਹਾਈ।",
      "new-zealand": "ਉੱਤਮ ਸਿੱਖਿਆ ਅਤੇ ਕੰਮ ਦੇ ਵਿਕਲਪਾਂ ਨਾਲ ਸੋਹਣੀਆਂ ਵਾਦੀਆਂ।",
      europe: "ਸ਼ੈਂਗਨ ਵੀਜ਼ਾ 'ਤੇ ਕਈ ਯੂਰਪੀ ਦੇਸ਼ਾਂ ਦੀ ਯਾਤਰਾ ਕਰੋ।",
      germany: "ਕੰਮ ਅਤੇ ਪੜ੍ਹਾਈ ਲਈ ਯੂਰਪ ਦੀ ਆਰਥਿਕ ਤਾਕਤ।",
      france: "ਯੂਰਪ ਦੇ ਦਿਲ ਵਿੱਚ ਸੱਭਿਆਚਾਰ, ਸਿੱਖਿਆ ਅਤੇ ਕਾਰੋਬਾਰ।",
      uae: "ਕਰੀਅਰ, ਕਾਰੋਬਾਰ ਅਤੇ ਸੈਰ-ਸਪਾਟੇ ਦਾ ਗਲੋਬਲ ਕੇਂਦਰ।",
    },
  },
  why: {
    eyebrow: "04 — ਸਾਡੀ ਖ਼ਾਸੀਅਤ", title: "THE TRIP WORLD ਹੀ ਕਿਉਂ?",
    desc: "ਇਮਾਨਦਾਰੀ, ਵਿਵਸਥਾ ਅਤੇ ਸੱਚੀ ਗਾਹਕ-ਦੇਖਭਾਲ 'ਤੇ ਆਧਾਰਿਤ ਕੰਸਲਟੈਂਸੀ ਤਜਰਬਾ।",
    items: [
      { title: "ਨਿੱਜੀ ਮਾਰਗਦਰਸ਼ਨ", text: "ਹਰ ਅਰਜ਼ੀਦਾਤਾ ਦੀ ਹਾਲਾਤਾਂ, ਟਿਚਿਆਂ ਅਤੇ ਯਾਤਰਾ ਇਤਿਹਾਸ ਅਨੁਸਾਰ ਮਾਰਗਦਰਸ਼ਨ।" },
      { title: "ਦਸਤਾਵੇਜ਼ ਸਹਾਇਤਾ", text: "ਅਰਜ਼ੀ ਦੇ ਦਸਤਾਵੇਜ਼ਾਂ ਨੂੰ ਸੁਵਿਵਸਥਿਤ ਕਰਨ ਵਿੱਚ ਪੇਸ਼ੇਵਰ ਸਹਾਇਤਾ।" },
      { title: "ਪਾਰਦਰਸ਼ੀ ਗੱਲਬਾਤ", text: "ਲੋੜਾਂ ਅਤੇ ਅਰਜ਼ੀ ਪੜਾਵਾਂ ਬਾਰੇ ਸਪਸ਼ਟ ਜਾਣਕਾਰੀ।" },
      { title: "ਪੇਸ਼ੇਵਰ ਪਹੁੰਚ", text: "ਸ਼ੁਰੂ ਤੋਂ ਅੰਤ ਤੱਕ ਸੁਵਿਵਸਥਿਤ ਸਲਾਹ ਪ੍ਰਕਿਰਿਆ।" },
      { title: "ਸੰਪੂਰਨ ਸਹਾਇਤਾ", text: "ਅਰਜ਼ੀ ਦੇ ਹਰ ਸੰਬੰਧਿਤ ਪੜਾਅ ਵਿੱਚ ਸਹਾਇਤਾ।" },
      { title: "ਗਾਹਕ-ਕੇਂਦ੍ਰਿਤ", text: "ਹਰ ਅਰਜ਼ੀਦਾਤਾ ਦੇ ਟਿਚਿਆਂ ਅਨੁਸਾਰ ਬਣਾਇਆ ਗਿਆ ਸਲਾਹ ਤਜਰਬਾ।" },
    ],
  },
  process: {
    eyebrow: "05 — ਪ੍ਰਕਿਰਿਆ", title: "ਅੱਗੇ ਦਾ ਸਪਸ਼ਟ ਰਾਹ",
    desc: "ਪਹਿਲੀ ਗੱਲਬਾਤ ਤੋਂ ਅਰਜ਼ੀ ਸਹਾਇਤਾ ਤੱਕ — ਚਾਰ ਸੁਵਿਵਸਥਿਤ ਪੜਾਅ।",
    items: [
      { title: "ਸਲਾਹ", text: "ਸਾਡੀ ਟੀਮ ਨਾਲ ਆਪਣੇ ਯਾਤਰਾ ਜਾਂ ਇਮੀਗਰੇਸ਼ਨ ਟਿਚਿਆਂ ਬਾਰੇ ਗੱਲ ਕਰੋ।" },
      { title: "ਪ੍ਰੋਫ਼ਾਈਲ ਅਤੇ ਦਸਤਾਵੇਜ਼ ਸਮੀਖਿਆ", text: "ਬੁਨਿਆਦੀ ਜਾਣਕਾਰੀ ਅਤੇ ਦਸਤਾਵੇਜ਼ ਲੋੜਾਂ ਦੀ ਸਮੀਖਿਆ।" },
      { title: "ਅਰਜ਼ੀ ਤਿਆਰੀ", text: "ਲੋੜੀਂਦੇ ਦਸਤਾਵੇਜ਼ ਤਿਆਰ ਅਤੇ ਸੁਵਿਵਸਥਿਤ ਕਰੋ।" },
      { title: "ਅਰਜ਼ੀ ਸਹਾਇਤਾ", text: "ਲਾਗੂ ਅਰਜ਼ੀ ਪ੍ਰਕਿਰਿਆ ਵਿੱਚ ਮਾਰਗਦਰਸ਼ਨ।" },
    ],
  },
  eligibility: {
    eyebrow: "06 — ਯੋਗਤਾ", title: "ਆਪਣੀ ਵੀਜ਼ਾ ਯੋਗਤਾ ਜਾਂਚੋ",
    desc: "ਆਪਣੀ ਪ੍ਰੋਫ਼ਾਈਲ ਅਤੇ ਟਿਚੇ ਦੱਸੋ — ਸਾਡੀ ਟੀਮ ਤੁਹਾਡੇ ਵੇਰਵਿਆਂ ਦੀ ਸਮੀਖਿਆ ਕਰਕੇ ਢੁਕਵੇਂ ਅਗਲੇ ਕਦਮ ਦੱਸੇਗੀ।",
    name: "ਨਾਮ", age: "ਉਮਰ", phone: "ਫ਼ੋਨ", email: "ਈਮੇਲ", education: "ਸਿੱਖਿਆ",
    occupation: "ਪੇਸ਼ਾ", experience: "ਕੰਮ ਦਾ ਤਜਰਬਾ", country: "ਪਸੰਦੀਦਾ ਦੇਸ਼",
    visaType: "ਵੀਜ਼ਾ ਕਿਸਮ", english: "IELTS / PTE ਸਥਿਤੀ", message: "ਸੁਨੇਹਾ (ਵਿਕਲਪਿਕ)",
    submit: "ਯੋਗਤਾ ਜਾਂਚੋ", submitting: "ਜਾਂਚ ਹੋ ਰਹੀ ਹੈ...",
    disclaimer: "ਇਹ ਸਿਰਫ਼ ਸ਼ੁਰੂਆਤੀ ਮੁਲਾਂਕਣ ਹੈ। ਅੰਤਿਮ ਵੀਜ਼ਾ ਫੈਸਲਾ ਸੰਬੰਧਿਤ ਇਮੀਗਰੇਸ਼ਨ ਅਧਿਕਾਰੀ ਲੈਂਦਾ ਹੈ ਅਤੇ ਯੋਗਤਾ ਵੀਜ਼ਾ ਮਨਜ਼ੂਰੀ ਦੀ ਗਾਰੰਟੀ ਨਹੀਂ ਦਿੰਦੀ।",
    successTitle: "ਪ੍ਰੋਫ਼ਾਈਲ ਮਿਲ ਗਈ।",
    successText: "ਧੰਨਵਾਦ। ਸਾਡੀ ਟੀਮ ਤੁਹਾਡੇ ਵੇਰਵਿਆਂ ਦੀ ਸਮੀਖਿਆ ਕਰਕੇ ਯੋਗਤਾ ਅਤੇ ਅਗਲੇ ਕਦਮਾਂ ਬਾਰੇ ਗੱਲ ਕਰਨ ਲਈ ਸੰਪਰਕ ਕਰੇਗੀ।",
  },
  stories: {
    eyebrow: "07 — ਸਫਲਤਾ ਦੀਆਂ ਕਹਾਣੀਆਂ", title: "ਜਿਨ੍ਹਾਂ ਸਫ਼ਰਾਂ ਦਾ ਅਸੀਂ ਮਾਰਗਦਰਸ਼ਨ ਕੀਤਾ",
    desc: "ਉਨ੍ਹਾਂ ਗਾਹਕਾਂ ਦੇ ਅਸਲੀ ਤਜਰਬੇ ਜਿਨ੍ਹਾਂ ਨੇ ਆਪਣੀਆਂ ਅਰਜ਼ੀਆਂ ਲਈ THE TRIP WORLD 'ਤੇ ਭਰੋਸਾ ਕੀਤਾ।",
    placeholderTitle: "ਸੱਚੀਆਂ ਕਹਾਣੀਆਂ, ਜਲਦੀ ਆ ਰਹੀਆਂ ਹਨ।",
    placeholderText: "ਅਸੀਂ ਸਿਰਫ਼ ਅਸਲੀ ਗਾਹਕ ਤਜਰਬੇ ਪ੍ਰਕਾਸ਼ਿਤ ਕਰਦੇ ਹਾਂ — ਅਸਲੀ ਨਾਮ, ਮੰਜ਼ਿਲਾਂ ਅਤੇ ਵੀਜ਼ਾ ਸ਼੍ਰੇਣੀਆਂ ਨਾਲ। ਜਿਵੇਂ-ਜਿਵੇਂ ਸਾਡੇ ਗਾਹਕ ਆਪਣੇ ਸਫ਼ਰ ਸਾਂਝੇ ਕਰਨਗੇ, ਉਨ੍ਹਾਂ ਦੀਆਂ ਕਹਾਣੀਆਂ ਇੱਥੇ ਦਿਖਣਗੀਆਂ।",
  },
  stats: {
    clients: "ਸਹਾਇਤਾ ਪ੍ਰਾਪਤ ਗਾਹਕ", applications: "ਸਹਾਇਤਾ ਕੀਤੀਆਂ ਅਰਜ਼ੀਆਂ",
    destinations: "ਮੰਜ਼ਿਲਾਂ", years: "ਸਾਲਾਂ ਦਾ ਤਜਰਬਾ",
  },
  docs: {
    eyebrow: "08 — ਤਿਆਰ ਰਹੋ", title: "ਤੁਹਾਨੂੰ ਕਿਹੜੇ ਦਸਤਾਵੇਜ਼ ਚਾਹੀਦੇ ਹੋ ਸਕਦੇ ਹਨ",
    desc: "ਵੀਜ਼ਾ ਅਰਜ਼ੀਆਂ ਵਿੱਚ ਆਮ ਤੌਰ 'ਤੇ ਲੋੜੀਂਦੇ ਦਸਤਾਵੇਜ਼ਾਂ ਦਾ ਆਮ ਪਰਿਚੈ।",
    note: "ਲੋੜਾਂ ਦੇਸ਼, ਵੀਜ਼ਾ ਸ਼੍ਰੇਣੀ ਅਤੇ ਨਿੱਜੀ ਹਾਲਾਤਾਂ ਅਨੁਸਾਰ ਵੱਖਰੀਆਂ ਹੁੰਦੀਆਂ ਹਨ।",
    items: [
      { title: "ਪਾਸਪੋਰਟ", text: "ਕਾਫ਼ੀ ਵੈਧਤਾ ਅਤੇ ਖਾਲੀ ਪੰਨਿਆਂ ਵਾਲਾ ਪਾਸਪੋਰਟ।" },
      { title: "ਫ਼ੋਟੋਆਂ", text: "ਮੰਜ਼ਿਲ ਦੇਸ਼ ਦੇ ਮਾਪਦੰਡਾਂ ਅਨੁਸਾਰ ਤਾਜ਼ਾ ਫ਼ੋਟੋਆਂ।" },
      { title: "ਵਿੱਤੀ ਦਸਤਾਵੇਜ਼", text: "ਬੈਂਕ ਸਟੇਟਮੈਂਟ ਅਤੇ ਫੰਡ ਦਾ ਸਬੂਤ (ਜਿਵੇਂ ਲਾਗੂ)।" },
      { title: "ਸਿੱਖਿਆ ਦਸਤਾਵੇਜ਼", text: "ਡਿਗਰੀਆਂ, ਡਿਪਲੋਮੇ ਅਤੇ ਅਕਾਦਮਿਕ ਟ੍ਰਾਂਸਕ੍ਰਿਪਟ।" },
      { title: "ਰੋਜ਼ਗਾਰ ਦਸਤਾਵੇਜ਼", text: "ਤਜਰਬਾ ਪੱਤਰ, ਔਫ਼ਰ ਅਤੇ ਮਾਲਕ ਰਿਕਾਰਡ।" },
      { title: "ਯਾਤਰਾ ਇਤਿਹਾਸ", text: "ਪਿਛਲੇ ਵੀਜ਼ਾ ਅਤੇ ਅੰਤਰਰਾਸ਼ਟਰੀ ਯਾਤਰਾ ਰਿਕਾਰਡ।" },
      { title: "ਸੱਦਾ / ਸਹਾਇਕ ਦਸਤਾਵੇਜ਼", text: "ਸੱਦਾ, ਸਪਾਂਸਰਸ਼ਿਪ ਜਾਂ ਦਾਖਲਾ ਪੱਤਰ।" },
      { title: "ਹੋਰ ਸਹਾਇਕ ਦਸਤਾਵੇਜ਼", text: "ਸ਼੍ਰੇਣੀ-ਵਿਸ਼ੇਸ਼ ਦਸਤਾਵੇਜ਼, ਜਿਵੇਂ ਲੋੜ ਹੋਵੇ।" },
    ],
  },
  faq: {
    eyebrow: "09 — ਸਵਾਲ", title: "ਅਕਸਰ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲ",
    desc: "ਸਾਡੇ ਤੋਂ ਸਭ ਤੋਂ ਵੱਧ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲਾਂ ਦੇ ਸਿੱਧੇ ਜਵਾਬ।",
    items: [
      { q: "THE TRIP WORLD ਕਿਹੜੀਆਂ ਵੀਜ਼ਾ ਸੇਵਾਵਾਂ ਦਿੰਦਾ ਹੈ?", a: "ਅਸੀਂ ਵਰਕ ਪਰਮਿਟ, ਵਿਜ਼ਿਟਰ, ਸਟੂਡੈਂਟ, ਫੈਮਿਲੀ/ਸਪਾਉਜ਼ ਅਤੇ ਬਿਜ਼ਨਸ ਵੀਜ਼ਾ ਲਈ ਸਲਾਹ ਅਤੇ ਅਰਜ਼ੀ ਸਹਾਇਤਾ ਦਿੰਦੇ ਹਾਂ, ਨਾਲ ਹੀ ਅੰਤਰਰਾਸ਼ਟਰੀ ਯਾਤਰਾ ਅਤੇ ਇਮੀਗਰੇਸ਼ਨ ਲਈ ਸੰਪੂਰਨ ਦਸਤਾਵੇਜ਼ ਸਹਾਇਤਾ ਵੀ।" },
      { q: "ਮੈਂ ਆਪਣੀ ਵੀਜ਼ਾ ਅਰਜ਼ੀ ਕਿਵੇਂ ਸ਼ੁਰੂ ਕਰਾਂ?", a: "ਮੁਫ਼ਤ ਸਲਾਹ ਨਾਲ ਸ਼ੁਰੂਆਤ ਕਰੋ। ਆਪਣਾ ਟਿਚਾ ਦੱਸੋ — ਸਾਡੀ ਟੀਮ ਤੁਹਾਡੀ ਪ੍ਰੋਫ਼ਾਈਲ ਵੇਖ ਕੇ ਆਮ ਲੋੜਾਂ ਅਤੇ ਤੁਹਾਡੇ ਲਈ ਢੁਕਵੇਂ ਕਦਮ ਦੱਸੇਗੀ।" },
      { q: "ਆਮ ਤੌਰ 'ਤੇ ਕਿਹੜੇ ਦਸਤਾਵੇਜ਼ ਚਾਹੀਦੇ ਹੁੰਦੇ ਹਨ?", a: "ਆਮ ਦਸਤਾਵੇਜ਼ਾਂ ਵਿੱਚ ਵੈਧ ਪਾਸਪੋਰਟ, ਫ਼ੋਟੋਆਂ, ਵਿੱਤੀ ਰਿਕਾਰਡ, ਸਿੱਖਿਆ ਅਤੇ ਰੋਜ਼ਗਾਰ ਦਸਤਾਵੇਜ਼ ਤੇ ਯਾਤਰਾ ਇਤਿਹਾਸ ਸ਼ਾਮਲ ਹਨ। ਸਹੀ ਲੋੜਾਂ ਦੇਸ਼, ਵੀਜ਼ਾ ਸ਼੍ਰੇਣੀ ਅਤੇ ਹਾਲਾਤਾਂ 'ਤੇ ਨਿਰਭਰ ਕਰਦੀਆਂ ਹਨ।" },
      { q: "ਵੀਜ਼ਾ ਪ੍ਰੋਸੈਸਿੰਗ ਵਿੱਚ ਕਿੰਨਾ ਸਮਾਂ ਲੱਗਦਾ ਹੈ?", a: "ਪ੍ਰੋਸੈਸਿੰਗ ਸਮਾਂ ਸੰਬੰਧਿਤ ਇਮੀਗਰੇਸ਼ਨ ਅਧਿਕਾਰੀ ਤੈਅ ਕਰਦਾ ਹੈ ਅਤੇ ਇਹ ਦੇਸ਼, ਵੀਜ਼ਾ ਸ਼੍ਰੇਣੀ ਅਤੇ ਅਰਜ਼ੀਆਂ ਦੀ ਗਿਣਤੀ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ। ਸਲਾਹ ਦੌਰਾਨ ਅਸੀਂ ਮੌਜੂਦਾ ਅਨੁਮਾਨਿਤ ਸਮਾਂ ਸਾਂਝਾ ਕਰਦੇ ਹਾਂ।" },
      { q: "ਕੀ ਤੁਸੀਂ ਮੇਰੇ ਦਸਤਾਵੇਜ਼ ਤਿਆਰ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰ ਸਕਦੇ ਹੋ?", a: "ਹਾਂ। ਦਸਤਾਵੇਜ਼ ਅਤੇ ਅਰਜ਼ੀ ਸਹਾਇਤਾ ਸਾਡੀਆਂ ਮੁੱਖ ਸੇਵਾਵਾਂ ਵਿੱਚੋਂ ਇੱਕ ਹੈ। ਅਸੀਂ ਤੁਹਾਡੇ ਦਸਤਾਵੇਜ਼ਾਂ ਨੂੰ ਸੁਵਿਵਸਥਿਤ ਕਰਨ, ਸਮੀਖਿਆ ਕਰਨ ਅਤੇ ਸਪਸ਼ਟ, ਪੂਰੀ ਅਰਜ਼ੀ ਫ਼ਾਈਲ ਤਿਆਰ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਦੇ ਹਾਂ।" },
      { q: "ਕੀ ਤੁਸੀਂ ਮੇਰੀ ਯੋਗਤਾ ਜਾਂਚ ਸਕਦੇ ਹੋ?", a: "ਹਾਂ। ਸਾਡਾ ਔਨਲਾਈਨ ਯੋਗਤਾ ਜਾਂਚਕਰਤਾ ਵਰਤੋ ਜਾਂ ਸਲਾਹ ਬੁੱਕ ਕਰੋ। ਧਿਆਨ ਦਿਓ — ਇਹ ਸਿਰਫ਼ ਸ਼ੁਰੂਆਤੀ ਮੁਲਾਂਕਣ ਹੈ; ਅੰਤਿਮ ਯੋਗਤਾ ਅਤੇ ਵੀਜ਼ਾ ਫੈਸਲਾ ਸੰਬੰਧਿਤ ਇਮੀਗਰੇਸ਼ਨ ਅਧਿਕਾਰੀ ਲੈਂਦਾ ਹੈ।" },
      { q: "ਤੁਸੀਂ ਕਿਹੜੇ ਦੇਸ਼ਾਂ ਲਈ ਸਹਾਇਤਾ ਕਰਦੇ ਹੋ?", a: "ਅਸੀਂ ਕੈਨੇਡਾ, ਯੂਕੇ, ਆਸਟ੍ਰੇਲੀਆ, ਅਮਰੀਕਾ, ਨਿਊਜ਼ੀਲੈਂਡ, ਯੂਰਪ (ਸ਼ੈਂਗਨ), ਜਰਮਨੀ, ਫਰਾਂਸ ਅਤੇ UAE ਦੀਆਂ ਅਰਜ਼ੀਆਂ ਵਿੱਚ ਸਹਾਇਤਾ ਕਰਦੇ ਹਾਂ, ਤੇ ਬੇਨਤੀ 'ਤੇ ਹੋਰ ਮੰਜ਼ਿਲਾਂ ਲਈ ਵੀ।" },
      { q: "ਕੀ THE TRIP WORLD ਵੀਜ਼ਾ ਮਨਜ਼ੂਰੀ ਦੀ ਗਾਰੰਟੀ ਦਿੰਦਾ ਹੈ?", a: "ਨਹੀਂ। ਵੀਜ਼ਾ ਫੈਸਲਾ ਪੂਰੀ ਤਰ੍ਹਾਂ ਸੰਬੰਧਿਤ ਇਮੀਗਰੇਸ਼ਨ ਅਧਿਕਾਰੀ ਲੈਂਦਾ ਹੈ ਅਤੇ ਕੋਈ ਵੀ ਕੰਸਲਟੈਂਸੀ ਮਨਜ਼ੂਰੀ ਦੀ ਗਾਰੰਟੀ ਨਹੀਂ ਦੇ ਸਕਦੀ। ਅਸੀਂ ਇਮਾਨਦਾਰ ਮਾਰਗਦਰਸ਼ਨ ਅਤੇ ਪੇਸ਼ੇਵਰ ਅਰਜ਼ੀ ਸਹਾਇਤਾ ਦਿੰਦੇ ਹਾਂ ਤਾਂ ਜੋ ਤੁਹਾਡਾ ਮਾਮਲਾ ਸਪਸ਼ਟ ਤਰੀਕੇ ਨਾਲ ਪੇਸ਼ ਹੋਵੇ।" },
    ],
  },
  blog: {
    eyebrow: "10 — ਜਰਨਲ", title: "ਜਾਣਕਾਰੀ ਅਤੇ ਅਪਡੇਟ",
    desc: "ਸਾਡੀ ਕੰਸਲਟੈਂਸੀ ਟੀਮ ਵੱਲੋਂ ਗਾਈਡ, ਦਸਤਾਵੇਜ਼ ਸਲਾਹ ਅਤੇ ਯਾਤਰਾ ਜਾਣਕਾਰੀ।",
    viewAll: "ਸਾਰੇ ਲੇਖ ਵੇਖੋ", read: "ਲੇਖ ਪੜ੍ਹੋ",
    emptyTitle: "ਲੇਖ ਜਲਦੀ ਆ ਰਹੇ ਹਨ।",
    emptyText: "ਸਾਡੇ ਜਰਨਲ ਵਿੱਚ ਵੀਜ਼ਾ ਮਾਰਗਦਰਸ਼ਨ, ਦਸਤਾਵੇਜ਼ ਸੁਝਾਅ ਅਤੇ ਮੰਜ਼ਿਲ ਜਾਣਕਾਰੀ ਹੋਵੇਗੀ — ਸਾਡੀ ਆਪਣੀ ਟੀਮ ਵੱਲੋਂ ਪ੍ਰਕਾਸ਼ਿਤ।",
  },
  contact: {
    eyebrow: "11 — ਸੰਪਰਕ ਕਰੋ", title: "ਆਓ ਤੁਹਾਡਾ ਸਫ਼ਰ ਸ਼ੁਰੂ ਕਰੀਏ",
    desc: "ਸਾਨੂੰ ਮਿਲੋ, ਕਾਲ ਕਰੋ ਜਾਂ ਸੁਨੇਹਾ ਭੇਜੋ — ਤੁਹਾਡੀ ਮੁਫ਼ਤ ਸਲਾਹ ਬਸ ਇੱਕ ਕਦਮ ਦੂਰ ਹੈ।",
    phone: "ਫ਼ੋਨ", emailLabel: "ਈਮੇਲ", website: "ਵੈੱਬਸਾਈਟ", location: "ਪਤਾ",
    call: "ਕਾਲ ਕਰੋ", whatsapp: "ਵਟਸਐਪ", emailBtn: "ਈਮੇਲ",
    formName: "ਪੂਰਾ ਨਾਮ", formPhone: "ਫ਼ੋਨ ਨੰਬਰ", formEmail: "ਈਮੇਲ ਪਤਾ",
    formMessage: "ਅਸੀਂ ਤੁਹਾਡੀ ਕਿਵੇਂ ਮਦਦ ਕਰ ਸਕਦੇ ਹਾਂ?", submit: "ਸੁਨੇਹਾ ਭੇਜੋ", sending: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
    successTitle: "ਸੁਨੇਹਾ ਮਿਲ ਗਿਆ।",
    successText: "ਸੰਪਰਕ ਕਰਨ ਲਈ ਧੰਨਵਾਦ। ਸਾਡੀ ਟੀਮ ਜਲਦੀ ਤੋਂ ਜਲਦੀ ਤੁਹਾਨੂੰ ਜਵਾਬ ਦੇਵੇਗੀ।",
    another: "ਹੋਰ ਸੁਨੇਹਾ ਭੇਜੋ",
  },
  cta: {
    title: "ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਤਿਆਰ ਹੋ?", heading: "ਤੁਹਾਡਾ ਸਫ਼ਰ ਇਥੋਂ ਸ਼ੁਰੂ",
    text: "THE TRIP WORLD ਨਾਲ ਮੁਫ਼ਤ ਸਲਾਹ ਬੁੱਕ ਕਰੋ ਅਤੇ ਆਪਣੇ ਵੀਜ਼ਾ ਸਫ਼ਰ ਲਈ ਸਪਸ਼ਟ, ਇਮਾਨਦਾਰ ਮਾਰਗਦਰਸ਼ਨ ਲਓ।",
    button: "ਮੁਫ਼ਤ ਸਲਾਹ ਲਓ",
  },
  footer: {
    blurb: "ਅਹਮਦਗੜ੍ਹ, ਪੰਜਾਬ ਸਥਿਤ ਪੇਸ਼ੇਵਰ ਇਮੀਗਰੇਸ਼ਨ ਅਤੇ ਵੀਜ਼ਾ ਕੰਸਲਟੈਂਸੀ — ਅੰਤਰਰਾਸ਼ਟਰੀ ਕੰਮ, ਪੜ੍ਹਾਈ ਅਤੇ ਯਾਤਰਾ ਦੇ ਮੌਕਿਆਂ ਵੱਲ ਤੁਹਾਡੇ ਸਫ਼ਰ ਦਾ ਮਾਰਗਦਰਸ਼ਨ।",
    company: "ਕੰਪਨੀ", servicesCol: "ਸੇਵਾਵਾਂ", quick: "ਤੁਰੰਤ ਲਿੰਕ", contactCol: "ਸੰਪਰਕ",
    eligibility: "ਯੋਗਤਾ",
    rights: "ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ।",
    privacy: "ਪਰਾਈਵੇਟ ਨੀਤੀ", terms: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ", disclaimerLink: "ਬੇਦਾਅਵਾ",
  },
  notFound: {
    eyebrow: "ਰਾਹ ਤੋਂ ਭੁੱਲ ਗਏ", title: "ਇਹ ਮੰਜ਼ਿਲ ਮੌਜੂਦ ਨਹੀਂ ਹੈ।",
    text: "ਤੁਸੀਂ ਜੋ ਪੇਜ ਲੱਭ ਰਹੇ ਹੋ ਉਹ ਹਟ ਗਿਆ ਹੈ ਜਾਂ ਕਦੇ ਸੀ ਹੀ ਨਹੀਂ। ਆਓ ਅਸੀਂ ਤੁਹਾਨੂੰ ਸਹੀ ਰਾਹ 'ਤੇ ਵਾਪਸ ਲੈ ਚਲੀਏ।",
    button: "ਹੋਮ 'ਤੇ ਵਾਪਸ ਜਾਓ",
  },
};
